module.exports = __webpack_public_path__ + "img/logo_full.0d899a21.png";